import { HUBFARM_BORDER_RADIUS, HUBFARM_BOX_SHADOW, HUBFARM_COLORS, HUBFARM_FONTS, HUBFARM_SPACING, } from '../hubfarmThemeConf';
export const hubfarmNotificationsStyle = {
    Containers: {
        DefaultStyle: {
            width: 500,
            top: 'auto',
            bottom: 0,
            margin: '0 auto 0 -250px',
            left: '50%',
        },
    },
    NotificationItem: {
        DefaultStyle: {
            width: 500,
            minHeight: 60,
            height: 'auto',
            border: 0,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            paddingLeft: '5.5em',
            borderRadius: HUBFARM_BORDER_RADIUS.default,
            boxShadow: HUBFARM_BOX_SHADOW.default,
        },
        success: {
            backgroundColor: HUBFARM_COLORS.primary.main,
        },
        info: {
            backgroundColor: HUBFARM_COLORS.brand.main,
        },
        error: {
            backgroundColor: HUBFARM_COLORS.error.main,
        },
        warning: {
            backgroundColor: HUBFARM_COLORS.warning.main,
        },
    },
    Dismiss: {
        DefaultStyle: {
            display: 'none',
        },
    },
    Title: {
        DefaultStyle: {
            color: HUBFARM_COLORS.font.light,
            fontSize: HUBFARM_FONTS.size.mediumBig,
            fontWeight: HUBFARM_FONTS.weight.bold,
            height: HUBFARM_FONTS.size.mediumBig,
            marginBottom: 0,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        },
    },
    MessageWrapper: {
        DefaultStyle: {
            minHeight: 20,
            fontSize: HUBFARM_FONTS.size.medium,
            fontWeight: HUBFARM_FONTS.weight.normal,
            lineHeight: 1.67,
            textAlign: 'left',
            color: HUBFARM_COLORS.font.light,
            marginTop: HUBFARM_SPACING.margin.smallest,
        },
    },
};
//# sourceMappingURL=hubfarmNotificationsStyle.js.map